module.exports = __webpack_public_path__ + "5f380706cfab33ce195dbc9f00ab59a1.svg";